// src/converters/season.ts
import { Season, Championship } from '@/model';
import {
  GetSeasonByIdResponse,
  GetSeasonItemResponse,
  GetSeasonResponse,
  PostSeasonResponse,
  PutSeasonCurrentStageResponse,
  PutSeasonResponse,
  SeasonChampionshipResponse,
} from '@/services/response/season';

export class SeasonConverter {
  private static mapChampionship(
    response?: SeasonChampionshipResponse | null,
  ): Championship | undefined {
    if (!response) return undefined;

    return {
      uuid: response.uuid,
      name: response.name,
      is_filtered: response.is_filtered ?? false,
      is_active: response.is_active ?? true,
      seasons: undefined,
      created_at: '',
      updated_at: '',
    };
  }

  private static baseSeasonFromResponse(
    response:
      | GetSeasonItemResponse
      | GetSeasonByIdResponse
      | PostSeasonResponse
      | PutSeasonResponse
      | PutSeasonCurrentStageResponse,
  ): Season {
    const championship = SeasonConverter.mapChampionship(response.championship);

    return {
      uuid: response.uuid,
      championship_uuid: response.championship.uuid,
      current_stage_uuid: response.current_stage
        ? response.current_stage.uuid
        : undefined,
      stages: undefined, // quando o contrato trouxer as stages completas, mapeia aqui
      type: response.type,
      year: response.year,
      is_filtered: response.is_filtered,
      is_active: response.is_active,
      standings_columns: response.standings_columns ?? null,
      created_at: response.created_at,
      updated_at: response.updated_at,
      championship,
    };
  }

  static toDomainFromGetItemResponse(response: GetSeasonItemResponse): Season {
    return SeasonConverter.baseSeasonFromResponse(response);
  }

  static toDomainFromPaginatedResponse(response: GetSeasonResponse): Season[] {
    return response.data.map(SeasonConverter.toDomainFromGetItemResponse);
  }

  static toDomainFromPostResponse(response: PostSeasonResponse): Season {
    return SeasonConverter.baseSeasonFromResponse(response);
  }

  static toDomainFromPutResponse(response: PutSeasonResponse): Season {
    return SeasonConverter.baseSeasonFromResponse(response);
  }

  static toDomainFromByIdResponse(response: GetSeasonByIdResponse): Season {
    return SeasonConverter.baseSeasonFromResponse(response);
  }

  static toDomainFromPutCurrentStageResponse(
    response: PutSeasonCurrentStageResponse,
  ): Season {
    return SeasonConverter.baseSeasonFromResponse(response);
  }
}
